import { render, staticRenderFns } from "./ChoosingAuth.vue?vue&type=template&id=53c67cbd&"
import script from "./ChoosingAuth.vue?vue&type=script&lang=js&"
export * from "./ChoosingAuth.vue?vue&type=script&lang=js&"
import style0 from "./ChoosingAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports